import React from 'react'
import CustomButton from '../custom-material/button/Button'
import { accountTypeCanHaveProduct } from '../../libs/learn-more'

const LearnMoreButton = ({ classes, subscription, group, product, handleOpen }) => {
  // Life Cycle Insights and Specialized Litigation have Learn More at product level; others at group level
  const groupName = (group.name || '').toUpperCase()
  if (product && !['LIFE-CYCLE INSIGHTS', 'SPECIALIZED LITIGATION COVERAGE'].includes(groupName)) return null
  if (!product && ['LIFE-CYCLE INSIGHTS', 'SPECIALIZED LITIGATION COVERAGE'].includes(groupName)) return null

  // Life Cycle Insights has multiple products; Specialized Litigation is individual products; others the group is the same as product
  const productName = product ? product.name : group.name
  if (!accountTypeCanHaveProduct(subscription.majorCategory, subscription.minorCategory, subscription.subClass, productName, groupName)) return null

  return (
    <CustomButton
      style={{marginTop: 4}}
      className={classes.learnMoreButton}
      onClick={handleOpen(productName)}
      variant='contained'
      size='small'
      color='secondary'
    >
      Learn More
    </CustomButton>
  )
}

export default LearnMoreButton
